import { sort_bottom, sort_top } from "@/assets/Inspiration-center";
import React, { useEffect, useState } from "react";
import "./index.less";
interface ISortOrder {
  collect_count: string;
  like_count: string;
  comment_count: string;
  share_count: string;
}
interface ISortBoxProps {
  renderProps?: (key: string, value: string) => void;
}

const SortBox: React.FC<ISortBoxProps> = (props) => {
  const { renderProps } = props;

  const [sortOrder, setSortOrder] = useState<ISortOrder>({
    collect_count: "",
    like_count: "",
    comment_count: "",
    share_count: "",
  });
  const toggleSort = (type) => {
    setSortOrder((prevState) => {
      const newSortOrder = {
        collect_count: "",
        like_count: "",
        comment_count: "",
        share_count: "",
        [type]:
          prevState[type] == ""
            ? "desc"
            : prevState[type] == "desc"
              ? "asc"
              : "",
      };
      return newSortOrder;
    });
  };

  const renderSortButton = (type) => {
    const isSortedTop = sortOrder[type.value];

    return (
      <div onClick={() => toggleSort(type.value)}>
        <p>{type.label}</p>
        <div>
          {isSortedTop == "asc" ? (
            <>
              <img src={sort_top} alt="" width={8} />
              <img src={sort_bottom} alt="" width={8} />
            </>
          ) : isSortedTop == "desc" ? (
            <>
              <img src={sort_bottom} className="sort_bottom" alt="" width={8} />
              <img src={sort_top} className="sort_top_r" alt="" width={8} />
            </>
          ) : (
            <>
              <img src={sort_top} alt="" width={8} />
              <img src={sort_top} className="sort_top_r" alt="" width={8} />
            </>
          )}
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (renderProps) {
      // 过滤出值为 true 的键
      const trueKeys = Object.keys(sortOrder).filter((key) => sortOrder[key]);
      const trueValues = Object.values(sortOrder).filter((val) => val);

      // 只传递值为 true 的键
      renderProps(trueKeys[0], trueValues[0]);
    }
  }, [sortOrder]);
  return (
    <div className="sort-box">
      {[
        {
          label: "点赞",
          value: "like_count",
        },
        {
          label: "评论",
          value: "comment_count",
        },
        {
          label: "收藏",
          value: "collect_count",
        },
        {
          label: "分享",
          value: "share_count",
        },
      ].map((type) => renderSortButton(type))}
    </div>
  );
};

export default SortBox;
